module.exports = __webpack_public_path__ + "img/scooter-locked-2x.731cf532.png";